module.exports = __webpack_public_path__ + "static/media/video_img_01.33e06912.png";